import React, { Component } from 'react';
import * as LOTTIE from 'lottie-web';

import PizzaMessJson from './PizzaMess.json';

class PizzaMess extends Component {
    constructor(props) {
        super(props);
        this.animation = null;

        this.state = {
          currentStage: 1
        }
    }
    componentDidMount() {
      this.animation = LOTTIE.loadAnimation({
        container: this.refs.mainCanvas, // Required
        animationData: PizzaMessJson,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: "Hello World", // Name for future reference. Optional.
      });
      window.onkeydown = this.checkKey.bind(this);
      this.animation.addEventListener('DOMLoaded', () => {
        this.animation.playSegments([[0, 100]],true);
        // this.animation.goToAndStop(100,true);
      });
    }
    componentWillReceiveProps(nextProps) {
      const { currentStage } = nextProps;
      if(currentStage !== this.state.currentStage) {
        this.setState({
          currentStage: currentStage
        });
      }
    }
    componentDidUpdate(prevProps) {
      if(this.state.currentStage === 1 && this.state.currentStage !== prevProps.currentStage) {
          this.animation.playSegments([[0, 150]], true);
      }
      if(this.state.currentStage === 2 && this.state.currentStage !== prevProps.currentStage) {
        this.animation.playSegments([[180, 250]], true);
      }
      if(this.state.currentStage === 3 && this.state.currentStage !== prevProps.currentStage) {
        this.animation.playSegments([[330, 400]], true);
      }
      if(this.state.currentStage === 4 && this.state.currentStage !== prevProps.currentStage) {
        this.animation.playSegments([[490, 600]], true);
      }
    }
    checkKey(e) {
      // console.log(e);
      if(e.key === '1') {
        
      }
      if(e.key === '2') {
        this.animation.playSegments([150, 250],true);
      }
      if(e.key === '3') {
        this.animation.playSegments([300, 400],true);
      }
      if(e.key === '4') {
        this.animation.playSegments([450, 600],true);
      }
    }
    componentWillUpdate() {

    }
    render() {
      const { label } = this.props;
      return (
        <div className="pizzaMessWrapper">
          <div className="pizzamessCopy">{ label }</div>
          <div className="pizzamess" ref="mainCanvas" style={{height: '120px', width: '120px'}}>
          </div>
        </div>
      )
  }
}

export default PizzaMess;



// WEBPACK FOOTER //
// ./src/components/modules/HomeHero/PizzaMess.js